<template>
    <div class="question">
        <div class="text">{{ question }}</div>
        <div class="buttons" v-if="answers && answers.length > 0">
            <button
                v-for="item in answers"
                :key="item.key"
                @click="$emit('select', item)"
            >
                {{ item.text }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Program',
    props: {
        question: {
            type: String,
            required: true,
        },
        answers: {
            type: Array,
            required: false,
        },
    },
    methods: {
        close() {
            this.$emit('close');
        },
    },
    computed: {
        hasBottom() {
            return this.item.status === 'completed';
        },
    },
};
</script>

<style scoped lang="scss">
    @import '~@/styles/rem';

    .text {
        /*font-family: Proxima Nova;*/
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        color: #2A2626;
        margin-bottom: 16px;
        white-space: pre-wrap;

        @include on-xs {
            font-size: 14px;
            line-height: 20px;
        }
    }
    .buttons {
        display: flex;
        justify-content: center;
        button {
            min-width: 120px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: #4663AB;
            padding: 0 46px;
            border: 0;
            height: 48px;
            background: #F7F7F8;
            border-radius: 4px;
            cursor: pointer;
            margin-right: 16px;

            &:hover {
                color: #FFFFFF;
                background-color: #4663AB;
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }
</style>